<template>
  <tr>
    <td>
        <user-presentation-card class="justify-content-center" :user="user" :with-info="false"></user-presentation-card>
    </td>
    <td v-text="user.name"></td>
    <td class="d-none d-md-table-cell" v-text="user.att_number"></td>
    <td>
        <button @click="save()" class="d-flex ml-auto btn btn-sm btn-success btn-with-icon">
          <i class="fa fa-plus"></i>
        </button>
    </td>
  </tr>
</template>
<script>
  export default {

      props:{
          user:{
              type: Object,
              required: true,
          },
          project: {
              type: Object,
              required: true,
          },
          version:{
          }
      },

      data(){
          return {
              form: new Form({
                  user_id: this.user.id,
                  version: this.version,
              }).dontClear()
          }
      },

      methods:{
          save() {
              this.form.post(`/projects/${this.project.slug}/work-team`).then(response => {
                  Toast.success(`The ATT ${this.user.name} was invited to this project.`)
                  this.$emit('invited', response);
              }).catch(error => {
                  Alert.error(error.first());
              })
          },
      },

      watch:{
          version(){
              this.form.version = this.version
          }
      }
  }
</script>
